import config from 'config';
import { http_client } from './api';

const getList = async (start = null, end = null, user_id = null) => {
  return http_client
    .get(
      config.apiUrl +
        'schedule?' +
        `${start ? 'start=' + start : ''}` +
        `${end ? '&end=' + end : ''}` +
        `${user_id ? '&user_id=' + user_id : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const getListArchive = async (year = null, month = null, user_id = null) => {
  return http_client
    .get(
      config.apiUrl +
        'schedule/archive?' +
        `${year ? 'year=' + year : ''}` +
        `${month ? '&month=' + month : ''}` +
        `${user_id ? '&user_id=' + user_id : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const getListDaily = async (date = null, user_id = null) => {
  return http_client
    .get(config.apiUrl + 'schedule/daily?' + `${date ? 'date=' + date : ''}` + `${user_id ? '&user_id=' + user_id : ''}`)
    .then((response) => {
      return response.data;
    });
};

const getListSemester = async (jenjang = null, cabang = null) => {
  const params = new URLSearchParams();
  if (jenjang && Array.isArray(jenjang) && jenjang.length > 0) {
    jenjang.forEach((id) => {
      params.append('jenjang[]', id);
    });
  } else if (jenjang) {
    params.append('jenjang', jenjang);
  }
  if (cabang) {
    params.append('cabang', cabang);
  }
  const queryString = params.toString();
  const url = config.apiUrl + 'schedule/semester' + (queryString ? '?' + queryString : '');
  return http_client
    .get(url)
    .then((response) => {
      return response.data;
    });
};

const getListWeekly = async (jenjang = null, cabang = null) => {
  const params = new URLSearchParams();
  if (jenjang && Array.isArray(jenjang) && jenjang.length > 0) {
    jenjang.forEach((id) => {
      params.append('jenjang[]', id);
    });
  } else if (jenjang) {
    params.append('jenjang', jenjang);
  }
  if (cabang) {
    params.append('cabang', cabang);
  }
  // Add cache busting timestamp
  params.append('_t', Date.now());
  const queryString = params.toString();
  const url = config.apiUrl + 'schedule/weekly' + (queryString ? '?' + queryString : '');
  return http_client
    .get(url)
    .then((response) => {
      return response.data;
    });
};

const getListTahunan = async (jenjang = null, cabang = null) => {
  const params = new URLSearchParams();
  if (jenjang && Array.isArray(jenjang) && jenjang.length > 0) {
    jenjang.forEach((id) => {
      params.append('jenjang[]', id);
    });
  } else if (jenjang) {
    params.append('jenjang', jenjang);
  }
  if (cabang) {
    params.append('cabang', cabang);
  }
  const queryString = params.toString();
  const url = config.apiUrl + 'schedule/tahunan' + (queryString ? '?' + queryString : '');
  return http_client
    .get(url)
    .then((response) => {
      return response.data;
    });
};

const getListBulanan = async (jenjang = null, cabang = null) => {
  const params = new URLSearchParams();
  if (jenjang && Array.isArray(jenjang) && jenjang.length > 0) {
    jenjang.forEach((id) => {
      params.append('jenjang[]', id);
    });
  } else if (jenjang) {
    params.append('jenjang', jenjang);
  }
  if (cabang) {
    params.append('cabang', cabang);
  }
  const queryString = params.toString();
  const url = config.apiUrl + 'schedule/bulanan' + (queryString ? '?' + queryString : '');
  return http_client
    .get(url)
    .then((response) => {
      return response.data;
    });
};

const getListMingguan = async (jenjang = null, cabang = null) => {
  const params = new URLSearchParams();
  if (jenjang && Array.isArray(jenjang) && jenjang.length > 0) {
    jenjang.forEach((id) => {
      params.append('jenjang[]', id);
    });
  } else if (jenjang) {
    params.append('jenjang', jenjang);
  }
  if (cabang) {
    params.append('cabang', cabang);
  }
  const queryString = params.toString();
  const url = config.apiUrl + 'schedule/mingguan' + (queryString ? '?' + queryString : '');
  return http_client
    .get(url)
    .then((response) => {
      return response.data;
    });
};

const getListHarian = async (jenjang = null, cabang = null) => {
  const params = new URLSearchParams();
  if (jenjang && Array.isArray(jenjang) && jenjang.length > 0) {
    jenjang.forEach((id) => {
      params.append('jenjang[]', id);
    });
  } else if (jenjang) {
    params.append('jenjang', jenjang);
  }
  if (cabang) {
    params.append('cabang', cabang);
  }
  const queryString = params.toString();
  const url = config.apiUrl + 'schedule/harian' + (queryString ? '?' + queryString : '');
  return http_client
    .get(url)
    .then((response) => {
      return response.data;
    });
};

const create = async (data) => {
  return http_client.post(config.apiUrl + 'schedule', data).then((response) => {
    return response.data;
  });
};

const read = async (id) => {
  return http_client.get(config.apiUrl + 'schedule/' + id).then((response) => {
    return response.data;
  });
};

const update = async (id, data) => {
  return http_client.patch(config.apiUrl + 'schedule/' + id, data).then((response) => {
    return response.data;
  });
};

const del = async (id) => {
  return http_client.delete(config.apiUrl + 'schedule/' + id).then((response) => {
    return response.data;
  });
};

const changeStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'schedule/' + id + '/status', data).then((response) => {
    return response.data;
  });
};

const changeStudentAttend = async (id, data) => {
  return http_client.post(config.apiUrl + 'schedule/' + id + '/attend', data).then((response) => {
    return response.data;
  });
};

const getStudentWeeklyCount = async (studentId, classScheduleId) => {
  return http_client
    .get(config.apiUrl + `schedule/student-weekly-count?student_id=${studentId}&class_schedule_id=${classScheduleId}`)
    .then((response) => {
      return response.data;
    });
};

/**
 * BULK API: Get weekly count untuk multiple students dalam 1 request
 * @param {Array} entries - Array of {student_id, class_schedule_id}
 * @returns {Object} - { "studentId_classScheduleId": count, ... }
 */
const getStudentWeeklyCountBulk = async (entries) => {
  return http_client
    .post(config.apiUrl + 'schedule/student-weekly-count-bulk', { entries })
    .then((response) => {
      return response.data;
    });
};

const uploadPhoto = async (id, data) => {
  return http_client.post(config.apiUrl + 'schedule/' + id + '/photos', data).then((response) => {
    return response.data;
  });
};

const deletePhoto = async (id, fileID) => {
  return http_client.delete(config.apiUrl + 'schedule/' + id + '/photos/' + fileID).then((response) => {
    return response.data;
  });
};

const exportSemesterSchedule = async () => {
  try {
    const today = new Date();
    const day = today.getDate().toString().padStart(2, '0');
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const year = today.getFullYear().toString();

    const response = await http_client.getFile(config.apiUrl + 'schedule/semester/export');

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `jadwal-semester-${day}-${month}-${year}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error exporting student data:', error);
  }
};

const exportWeeklySchedule = async () => {
  try {
    const today = new Date();
    const day = today.getDate().toString().padStart(2, '0');
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const year = today.getFullYear().toString();

    const response = await http_client.getFile(config.apiUrl + 'schedule/weekly/export');

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `jadwal-mingguan-${day}-${month}-${year}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error exporting student data:', error);
  }
};

const exportTahunanSchedule = async () => {
  try {
    const today = new Date();
    const day = today.getDate().toString().padStart(2, '0');
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const year = today.getFullYear().toString();

    const response = await http_client.getFile(config.apiUrl + 'schedule/tahunan/export');

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `jadwal-tahunan-${day}-${month}-${year}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error exporting student data:', error);
  }
};

const exportBulananSchedule = async () => {
  try {
    const today = new Date();
    const day = today.getDate().toString().padStart(2, '0');
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const year = today.getFullYear().toString();

    const response = await http_client.getFile(config.apiUrl + 'schedule/bulanan/export');

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `jadwal-bulanan-${day}-${month}-${year}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error exporting student data:', error);
  }
};

const exportHarianSchedule = async () => {
  try {
    const today = new Date();
    const day = today.getDate().toString().padStart(2, '0');
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const year = today.getFullYear().toString();

    const response = await http_client.getFile(config.apiUrl + 'schedule/harian/export');

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `jadwal-harian-${day}-${month}-${year}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error exporting student data:', error);
  }
};

const exportAllSchedules = async () => {
  try {
    const today = new Date();
    const day = today.getDate().toString().padStart(2, '0');
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const year = today.getFullYear().toString();

    const response = await http_client.getFile(config.apiUrl + 'schedule/export-all');

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `jadwal-semua-${day}-${month}-${year}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error exporting all schedules:', error);
  }
};

const exportTeacherAttendance = async (type = 'all', startDate = null, endDate = null) => {
  try {
    const today = new Date();
    const day = today.getDate().toString().padStart(2, '0');
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const year = today.getFullYear().toString();

    const params = new URLSearchParams();
    params.append('type', type);
    if (startDate) {
      params.append('start_date', startDate);
    }
    if (endDate) {
      params.append('end_date', endDate);
    }

    const response = await http_client.getFile(config.apiUrl + 'schedule/attendance/export?' + params.toString());

    const rangePart = startDate || endDate ? `-${startDate || 'awal'}_${endDate || 'akhir'}` : '';
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `absensi-guru-${type}${rangePart}-${day}-${month}-${year}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error exporting teacher attendance:', error);
  }
};

/**
 * Check for schedule conflicts
 * @param {number} userId - User ID (guru)
 * @param {number} dayId - Day ID
 * @param {string} startTime - Start time (HH:mm)
 * @param {string} endTime - End time (HH:mm)
 * @param {number} excludeScheduleId - Schedule ID to exclude (for edit mode)
 * @param {number} classScheduleId - Class Schedule ID to filter (optional, untuk hanya cek jadwal di class_schedule yang sama)
 * @param {string} oldStartTime - Old start time (HH:mm) - untuk exclude schedule dengan waktu lama saat edit
 * @param {string} oldEndTime - Old end time (HH:mm) - untuk exclude schedule dengan waktu lama saat edit
 * @returns {Promise<Array>} Array of conflicting schedules
 */
const shareScheduleToWhatsApp = async (scheduleId, studentId) => {
  return http_client.get(config.apiUrl + `schedule/${scheduleId}/whatsapp/${studentId}`).then((response) => {
    return response.data;
  });
};

const shareScheduleToAllStudents = async (scheduleId) => {
  return http_client.get(config.apiUrl + `schedule/${scheduleId}/whatsapp`).then((response) => {
    return response.data;
  });
};

const shareClassScheduleToAllStudents = async (classScheduleId, cabangId = null) => {
  const url = cabangId 
    ? config.apiUrl + `class-schedule/${classScheduleId}/whatsapp?cabang_id=${cabangId}`
    : config.apiUrl + `class-schedule/${classScheduleId}/whatsapp`;
  return http_client.get(url).then((response) => {
    return response.data;
  });
};

const checkScheduleConflict = async (userId, dayId, startTime, endTime, excludeScheduleId = null, classScheduleId = null, oldStartTime = null, oldEndTime = null) => {
  try {
    if (!userId || !dayId || !startTime || !endTime) {
      return [];
    }

    // Get all schedules for this user
    // Note: Endpoint ini mengembalikan semua schedule user (termasuk yang menggunakan day_id)
    // tanpa filter date, sehingga bisa mendeteksi konflik untuk weekly schedule
    const response = await http_client.get(config.apiUrl + `schedule?user_id=${userId}`);
    // Response structure: { message: "...", data: [...] }
    const schedules = response?.data?.data || [];
    
    // Helper function to extract time from various formats
    // PENTING: API mengembalikan waktu dalam UTC (dengan suffix Z), tapi form menggunakan waktu lokal
    // Jadi perlu konversi UTC ke lokal (UTC+7) untuk perbandingan yang benar
    const extractTime = (timeValue) => {
      if (!timeValue) {
        return null;
      }
      
      // If it's already in HH:mm format (waktu lokal dari form)
      if (typeof timeValue === 'string' && timeValue.match(/^\d{2}:\d{2}$/)) {
        return timeValue;
      }
      
      // If it's datetime string, extract time part and convert to local time
      if (typeof timeValue === 'string') {
        // Handle UTC format: "2024-01-01T12:00:00.000000Z" (ends with Z = UTC)
        if (timeValue.includes('T') && timeValue.includes('Z')) {
          // Parse as Date to automatically convert to local time
          const date = new Date(timeValue);
          const hours = date.getHours().toString().padStart(2, '0');
          const minutes = date.getMinutes().toString().padStart(2, '0');
          return `${hours}:${minutes}`;
        }
        
        // Handle non-UTC format: "2024-01-01T12:00:00" or "2024-01-01 12:00:00"
        if (timeValue.includes('T')) {
          const parts = timeValue.split('T');
          if (parts.length > 1) {
            const timePart = parts[1].split('.')[0]; // Remove microseconds if present
            return timePart ? timePart.substring(0, 5) : null;
          }
        }
        if (timeValue.includes(' ')) {
          const parts = timeValue.split(' ');
          if (parts.length > 1) {
            const timePart = parts[1];
            return timePart ? timePart.substring(0, 5) : null;
          }
        }
      }
      
      return null;
    };

    // Convert to minutes for easier comparison
    const timeToMinutes = (timeStr) => {
      if (!timeStr) return null;
      const parts = timeStr.split(':');
      if (parts.length !== 2) return null;
      const hours = parseInt(parts[0], 10);
      const minutes = parseInt(parts[1], 10);
      if (isNaN(hours) || isNaN(minutes)) return null;
      return hours * 60 + minutes;
    };
    
    // Filter by day_id and check time overlap
    const conflicts = schedules.filter((schedule) => {
      // Exclude current schedule if editing
      const excludeId = excludeScheduleId ? parseInt(excludeScheduleId, 10) : null;
      const scheduleId = parseInt(schedule.id, 10);
      
      if (excludeId && scheduleId === excludeId) {
        return false;
      }
      
      // Must be same day
      const scheduleDayId = schedule.day_id;
      const targetDayId = parseInt(dayId);
      if (scheduleDayId !== targetDayId) {
        return false;
      }
      
      // Filter by class_schedule_id - hanya cek konflik dari class_schedule yang sama
      if (classScheduleId) {
        const scheduleClassScheduleId = parseInt(schedule.class_schedule_id, 10);
        const targetClassScheduleId = parseInt(classScheduleId, 10);
        
        if (isNaN(scheduleClassScheduleId) || scheduleClassScheduleId !== targetClassScheduleId) {
          return false;
        }
      }
      
      // Must be published (available)
      // If status exists and is not 'available', skip it
      // If status doesn't exist, assume it's available (for backward compatibility)
      const scheduleStatus = schedule.status;
      if (scheduleStatus && scheduleStatus !== 'available') {
        return false;
      }
      
      // Filter: hanya ambil schedule yang class_schedule-nya aktif dan belum lewat end_date
      // (hanya schedule yang benar-benar aktif)
      // CATATAN: Filter ini opsional - jika classSchedule relation tidak ada, tetap cek konflik
      if (schedule.classSchedule) {
        const classScheduleStatus = schedule.classSchedule.status;
        // Jika status ada dan bukan 'active', skip
        if (classScheduleStatus && classScheduleStatus !== 'active') {
          return false;
        }
        
        // Filter: hanya ambil schedule yang belum lewat end_date (masih aktif)
        if (schedule.classSchedule.end_date) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const endDateStr = schedule.classSchedule.end_date;
          const endDate = new Date(endDateStr);
          endDate.setHours(0, 0, 0, 0);
          
          // Jika end_date sudah lewat, skip (sudah archive)
          if (endDate < today) {
            return false;
          }
        }
      }
      // Note: Jika classSchedule relation tidak ada, tetap lanjutkan cek konflik
      // (mungkin API tidak include relation, tapi jadwal tetap harus dicek untuk konflik)
      
      // Extract times
      const existingStart = extractTime(schedule.start_time);
      const existingEnd = extractTime(schedule.end_time);
      
      if (!existingStart || !existingEnd) {
        return false;
      }
      
      // Exclude schedule dengan waktu lama saat edit (untuk handle multi-mapel dengan waktu sama)
      // Jika waktu schedule sama dengan waktu lama, berarti ini adalah schedule yang sedang diedit
      if (oldStartTime && oldEndTime && existingStart === oldStartTime && existingEnd === oldEndTime) {
        return false;
      }
      
      // Convert to minutes
      const newStart = timeToMinutes(startTime);
      const newEnd = timeToMinutes(endTime);
      const existStart = timeToMinutes(existingStart);
      const existEnd = timeToMinutes(existingEnd);
      
      if (newStart === null || newEnd === null || existStart === null || existEnd === null) {
        return false;
      }
      
      // Check if time ranges overlap
      // Overlap occurs if: newStart < existEnd AND newEnd > existStart
      // Example: 
      // - Existing: 12:00-14:00 (720-840), New: 12:15-13:00 (735-780)
      // - 735 < 840 ✓ AND 780 > 720 ✓ → OVERLAP!
      // - Existing: 12:00-13:00 (720-780), New: 13:00-14:00 (780-840)
      // - 780 < 780 ✗ → NO OVERLAP (touching but not overlapping)
      const hasOverlap = newStart < existEnd && newEnd > existStart;
      
      return hasOverlap;
    });
    
    // Filter duplikat berdasarkan waktu yang sama
    // Jika ada beberapa jadwal dengan waktu yang sama (beda mapel), hanya tampilkan 1
    const uniqueConflicts = [];
    const seenTimes = new Set();
    
    for (const conflict of conflicts) {
      const existingStart = extractTime(conflict.start_time);
      const existingEnd = extractTime(conflict.end_time);
      const timeKey = `${existingStart}-${existingEnd}`;
      
      if (!seenTimes.has(timeKey)) {
        seenTimes.add(timeKey);
        uniqueConflicts.push(conflict);
      }
    }
    
    return uniqueConflicts;
  } catch (error) {
    console.error('Error checking schedule conflict:', error);
    return [];
  }
};

/**
 * Mengubah type class schedule menjadi label berbahasa Indonesia
 * @param {string} type - tahunan | semester | bulanan | mingguan | weekly | harian
 * @returns {string} Label tipe jadwal
 */
const getScheduleTypeLabel = (type) => {
  switch ((type || '').toString().toLowerCase()) {
    case 'tahunan':
      return 'Tahunan';
    case 'semester':
      return 'Semester';
    case 'bulanan':
      return 'Bulanan';
    case 'mingguan':
    case 'weekly':
      return 'Mingguan';
    case 'harian':
      return 'Harian';
    default:
      return 'Jadwal';
  }
};

/**
 * Cek tabrakan jadwal murid (scope: dalam class_schedule yang sama, mirror logika guru)
 * @param {number} studentId - ID murid
 * @param {number} dayId - Day ID
 * @param {string} startTime - Start time (HH:mm)
 * @param {string} endTime - End time (HH:mm)
 * @param {number} excludeScheduleId - Schedule ID yang di-exclude (edit mode)
 * @param {number} classScheduleId - Class Schedule ID (scope)
 * @param {string} oldStartTime - Waktu lama untuk exclude slot saat edit multi-mapel
 * @param {string} oldEndTime - Waktu lama untuk exclude slot saat edit multi-mapel
 * @returns {Promise<Array>} Array jadwal konflik (sudah dedupe per slot waktu)
 */
const checkStudentScheduleConflict = async (
  studentId,
  dayId,
  startTime,
  endTime,
  excludeScheduleId = null,
  classScheduleId = null,
  oldStartTime = null,
  oldEndTime = null
) => {
  try {
    if (!studentId || !dayId || !startTime || !endTime || !classScheduleId) {
      return [];
    }

    const params = new URLSearchParams();
    params.append('student_id', studentId);
    params.append('day_id', dayId);
    params.append('start_time', startTime);
    params.append('end_time', endTime);
    params.append('class_schedule_id', classScheduleId);
    if (excludeScheduleId) {
      params.append('exclude_schedule_id', excludeScheduleId);
    }
    if (oldStartTime) {
      params.append('old_start_time', oldStartTime);
    }
    if (oldEndTime) {
      params.append('old_end_time', oldEndTime);
    }

    const response = await http_client.get(config.apiUrl + 'schedule/check-student-conflict?' + params.toString());
    return response?.data?.data || [];
  } catch (error) {
    console.error('Error checking student schedule conflict:', error);
    return [];
  }
};

const CabangService = {
  getList,
  getListArchive,
  getListDaily,
  create,
  read,
  update,
  del,
  changeStatus,
  changeStudentAttend,
  getStudentWeeklyCount,
  getStudentWeeklyCountBulk, // BULK API: 1 request untuk semua siswa
  uploadPhoto,
  deletePhoto,
  getListSemester,
  getListWeekly,
  getListTahunan,
  getListBulanan,
  getListMingguan,
  getListHarian,
  exportSemesterSchedule,
  exportWeeklySchedule,
  exportTahunanSchedule,
  exportBulananSchedule,
  exportHarianSchedule,
  exportAllSchedules,
  exportTeacherAttendance,
  checkScheduleConflict,
  checkStudentScheduleConflict,
  getScheduleTypeLabel,
  shareScheduleToWhatsApp,
  shareScheduleToAllStudents,
  shareClassScheduleToAllStudents
};

export default CabangService;
